export const KIOSK_PING_PATH = '/kiosk-ping.txt'; // nginx logs each request. Nothing reads the response.
export const KIOSK_PING_INTERVAL_MS = 60 * 60 * 1000;
export const KIOSK_PING_SCHEMA_VERSION = 1;

export type KioskPingEvent = 'boot' | 'heartbeat';

export type KioskPingParams = {
  event: KioskPingEvent;
  companyId: number | string;
  locationId: string;
  token: string;
  kioskId: string;
  setupAt: Date | string | null | undefined;
  uptimeSeconds: number;
};

function toIsoString(value: Date | string | null | undefined): string | null {
  if (!value) return null;

  const date = value instanceof Date ? value : new Date(value);

  return Number.isNaN(date.getTime()) ? null : date.toISOString();
}

export function buildKioskPingUrl(params: KioskPingParams): string {
  const fields: Record<string, string> = {
    v: String(KIOSK_PING_SCHEMA_VERSION),
    event: params.event,
    company_id: String(params.companyId),
    location_id: params.locationId,
    // Never send the full token. It is a bearer credential.
    token_last4: params.token.slice(-4),
    kiosk_id: params.kioskId,
    uptime_s: String(Math.max(0, Math.round(params.uptimeSeconds))),
  };

  const setupAt = toIsoString(params.setupAt);

  if (setupAt) fields['setup_at'] = setupAt;

  return `${KIOSK_PING_PATH}?${new URLSearchParams(fields).toString()}`;
}
